'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ImgixService.$inject = ['ImgixConstants'];


var _module = _angular2.default.module('cb.image.ImgixService', []);

_module.service('ImgixService', ImgixService);

exports.default = _module;


function ImgixService(ImgixConstants) {
    return {
        getUrl: getUrl
    };

    /**
     * ImgixService.getUrl returns an URL from our image proxy, imgix.
     * Default params for imgix are in img.constants
     * They can be overwritten with the params variable
     *
     * @param {String} url
     * @param {Object} params
     * @return {String} url
     */
    function getUrl(url, params) {
        var _url = ImgixConstants.IMG_SERVICE_URL + url;

        var variables = [];
        if (params) {
            variables = params;
        }

        //If user does not define parameters in url, use defaults + variables from calling element
        if (_url.indexOf('?') === -1) {
            _url += '?';
            variables = (0, _merge3.default)(ImgixConstants.DEFAULT_PARAMS, variables);
        }

        _angular2.default.forEach(variables, function (value, key) {
            _url += '&' + key + '=' + value;
        });

        return _url;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/image/imgix.service.js
// module id = 810
// module chunks = 0